/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import { ScoreTimelineItemWrap } from '@views/Matchup/MatchUpDetail/index.style'
import halfTimeTxtImg from '@assets/images/bg/dash-board/half-time-txt.png'
import { BASIC_TEAM_EMBLEM_MAP } from '@shared/EmblemGroup'

interface ScoreTimelineData {
  homeTeamEmblemUrl: string
  awayTeamEmblemUrl: string
  homeTeamName: string
  awayTeamName: string
  homeTeamScore: number
  awayTeamScore: number
  sportId: number
}

interface HalftimeTimelineItemProps {
  scoreTimelineData: ScoreTimelineData
  className?: string
}

export const HalftimeTimelineItem: React.FC<HalftimeTimelineItemProps>
  = observer(({ scoreTimelineData, className }) => {
  const {
    homeTeamEmblemUrl,
    awayTeamEmblemUrl,
    homeTeamName,
    awayTeamName,
    homeTeamScore,
    awayTeamScore,
    sportId,
  } = scoreTimelineData

  return (
    <ScoreTimelineItemWrap className={className}>
      <div className="info-txt half-time"><img src={halfTimeTxtImg} alt="Half-Time" loading="lazy"/></div>
      <div className="half-time-line-item">
        <img className="emblem-img" src={homeTeamEmblemUrl || BASIC_TEAM_EMBLEM_MAP[sportId]} alt={homeTeamName} loading="lazy"/>
        <span className="team-name">{homeTeamName}</span>
        <span>{homeTeamScore}</span>
      </div>
      <div className="half-time-line-item">
        <img className="emblem-img" src={awayTeamEmblemUrl || BASIC_TEAM_EMBLEM_MAP[sportId]} alt={awayTeamName} loading="lazy"/>
        <span className="team-name">{awayTeamName}</span>
        <span>{awayTeamScore}</span>
      </div>
    </ScoreTimelineItemWrap>
  )
})
